import { Rout_create } from './Rout.create'
import { Rout_replace, Rout_to } from './Rout'
import type { Rpts_ClientId } from '../Rpts/Rpts.types'
import type { ElementId } from '../../../shared/domain/flows/types.no-deps'
import ActivityStore from '../../src/stores/activity'

export interface Rout_ActivityRoutesArgs {
    Acti_ActivityPage: React.FunctionComponent<unknown>
    Acti_FlowExecutionPage: React.FunctionComponent<unknown>
}

export const Rout_ActivityRoutes = (args: Rout_ActivityRoutesArgs) => {
    return [
        Rout_create('/activity/flow/:reportId/:actionTypeId', args.Acti_FlowExecutionPage),
        Rout_create('/activity/:locationId/selectAction', args.Acti_ActivityPage),
        Rout_create('/activity/:locationId/addNote', args.Acti_ActivityPage),
        Rout_create('/activity/:locationId/formActivity', args.Acti_ActivityPage),
        Rout_create('/activity/:locationId/unitFormActivity', args.Acti_ActivityPage),
        Rout_create('/activity/:locationId/unitFormActivity/form', args.Acti_ActivityPage),
        Rout_create('/activity/:locationId/unitFormActivity/addUnits/:unitTypeId', args.Acti_ActivityPage),
        Rout_create('/activity/:locationId/unitFormActivity/addUnits', args.Acti_ActivityPage),
    ]
}

export type Rout_ActivityPage = 'selectAction' | 'addNote' | 'formActivity' | 'unitFormActivity'
export type Rout_ActivitySubpage = 'select' | 'form' | 'addUnits'

export function Rout_getActivityPage(route: { path: string }): Rout_ActivityPage {
    if (route.path === '/activity/:locationId/selectAction') return 'selectAction'
    if (route.path === '/activity/:locationId/addNote') return 'addNote'
    if (route.path === '/activity/:locationId/formActivity') return 'formActivity'
    if (route.path === '/activity/:locationId/unitFormActivity') return 'unitFormActivity'
    if (route.path === '/activity/:locationId/unitFormActivity/form') return 'unitFormActivity'
    if (route.path === '/activity/:locationId/unitFormActivity/addUnits/:unitTypeId') return 'unitFormActivity'
    if (route.path === '/activity/:locationId/unitFormActivity/addUnits') return 'unitFormActivity'
    return 'selectAction'
}

export function Rout_getActivitySubpage(route: { path: string }): Rout_ActivitySubpage {
    if (route.path === '/activity/:locationId/selectAction') return null
    if (route.path === '/activity/:locationId/addNote') return null
    if (route.path === '/activity/:locationId/formActivity') return null
    if (route.path === '/activity/:locationId/unitFormActivity') return 'select'
    if (route.path === '/activity/:locationId/unitFormActivity/form') return 'form'
    if (route.path === '/activity/:locationId/unitFormActivity/addUnits/:unitTypeId') return 'addUnits'
    if (route.path === '/activity/:locationId/unitFormActivity/addUnits') return 'addUnits'
    return null
}

const getCurrentLocationId = () => ActivityStore.getSelectedStore().id

export function Rout_toActivityBase() {
    Rout_to(`/activity/${getCurrentLocationId()}/selectAction`)
}

export function Rout_replaceWithActivityBase(locationId: number) {
    Rout_replace(`/activity/${locationId}/selectAction`)
}

export function Rout_toActivityAddNote() {
    Rout_to(`/activity/${getCurrentLocationId()}/addNote`)
}

export function Rout_toForm() {
    Rout_to(`/activity/${getCurrentLocationId()}/formActivity`)
}

export function Rout_toUnitFormTable() {
    Rout_to(`/activity/${getCurrentLocationId()}/unitFormActivity`)
}

export function Rout_toUnitFormForm() {
    Rout_to(`/activity/${getCurrentLocationId()}/unitFormActivity/form`)
}

export function Rout_toUnitFormAdd(unitTypeId?: number, parentIds?: number[]) {
    if (unitTypeId != null) {
        Rout_to(`/activity/${getCurrentLocationId()}/unitFormActivity/addUnits/${unitTypeId}`, {
            parentIds: parentIds ? parentIds.join(',') : null,
        })
    } else {
        Rout_to(`/activity/${getCurrentLocationId()}/unitFormActivity/addUnits`)
    }
}

export function Rout_toActivityFlowExecution(
    reportId: Rpts_ClientId,
    actionTypeId: number,
    opts?: { sectionId?: ElementId }
) {
    Rout_to(`/activity/flow/${reportId}/${actionTypeId}`, opts)
}
